module.exports = "//static.hsappstatic.net/knowledge-content-ui/static-1.40526/img/start-knowledge-base.png"